import { InjectionToken } from "@angular/core";
import type { WkDataTableColumnRegistration, WkDataTableId, WkDataTableRowRegistration } from "./data-table.types";

export const WK_DATATABLE_ID = new InjectionToken<WkDataTableId>("WK_DATATABLE_ID", {
    factory: () => "",
});

export const WK_DATATABLE_COLUMN_REGISTRY = new InjectionToken<WkDataTableColumnRegistration[]>("COLUMN_REGISTRY");

export const WK_DATATABLE_ROW_REGISTRY = new InjectionToken<WkDataTableRowRegistration[]>("ROW_REGISTRY");

export function getWkDataTableColumnRegistry<T extends WkDataTableColumnRegistration>(): InjectionToken<T[]> {
    return WK_DATATABLE_COLUMN_REGISTRY as InjectionToken<T[]>;
}

export function getWkDataTableRowRegistry<T extends WkDataTableRowRegistration>(): InjectionToken<T[]> {
    return WK_DATATABLE_ROW_REGISTRY as InjectionToken<T[]>;
}
